"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74221],{

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 50550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-close {\n    top: 20px;\n    right: 30px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    border: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 40px 50px 30px;\n  }\n\n  .ant-modal-close {\n    top: 3%;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    height: 90%;\n    overflow-y: scroll;\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-f78b26fb-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}));


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 97052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GuestUserPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 3 modules
var queryClient = __webpack_require__(51767);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/user/Guest/guest.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;  \n  max-width: 930px;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  margin-bottom: 16px;\n  padding: 20px;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  position: relative;\n\n  h1, p {\n    margin: 0;\n    color: #333333;\n  }\n\n  h1 {\n    font-size: 30px;\n  }\n\n  p {\n    color: #00ab6b;\n    cursor: pointer;\n    font-size: 16px;\n  }\n\n  p, .username {\n    flex: 1;\n  }\n\n  button {\n    background: #ffffff;\n    border-radius: 4px;\n    border: 1px solid #E0E0E0;\n    color: #969696;\n    cursor: pointer;\n    font-weight: 600;\n    padding: 3px 12px;\n  }\n\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n  \n    margin-bottom: 10px;\n\n    h1 {\n      font-size: 24px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    button {\n      position: absolute;\n      right: 0;\n      top: 5px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    margin: 0;\n    color: #969696;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 5px;\n  flex-direction: row;\n  margin-top: 4px;\n\n  p {\n    margin: 0;\n    color: #333333;\n    font-weight: 600;\n  }\n\n  span {\n    color: #969696;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var GuestUserWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-0"
})(_templateObject());
var ProfileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-1"
})(_templateObject1());
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-2"
})(_templateObject2());
var ProfileInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-3"
})(_templateObject3());
var TopHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-4"
})(_templateObject4());
var MidleHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-5"
})(_templateObject5());
var BottomHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-6"
})(_templateObject6());
var StreamWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5793b4ed-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/user/Guest/ProfileSkeleton.tsx



function ProfileSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {
                    size: 150,
                    active: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                active: true,
                                style: {
                                    width: 100,
                                    height: 30
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                active: true,
                                style: {
                                    width: 70,
                                    height: 24
                                },
                                className: "username"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                active: true,
                                style: {
                                    width: 70,
                                    height: 26
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MidleHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                            active: true,
                            style: {
                                width: 80,
                                height: 22,
                                marginTop: 6
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                active: true,
                                style: {
                                    width: 60,
                                    height: 22,
                                    marginTop: 6
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                active: true,
                                style: {
                                    width: 60,
                                    height: 22,
                                    marginTop: 6
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/user/Guest/utils.ts
var utils = __webpack_require__(66965);
;// CONCATENATED MODULE: ./src/features/user/Guest/Profile.tsx
/* eslint-disable @next/next/no-img-element */ 





function Profile(param) {
    var user = param.user;
    var ref = (0,utils/* extractUserData */.Lt)(user), username = ref.username, fullname = ref.fullname, avatarUrl = ref.avatarUrl, ideaCount = ref.ideaCount, followerCount = ref.followerCount, userData = ref.userData;
    if (!username) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: avatarUrl,
                    alt: username,
                    width: 150,
                    height: 150,
                    style: {
                        borderRadius: "50%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: fullname
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "@",
                                    username
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/login",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        children: "Follow"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MidleHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Joined: ",
                                (0,format/* default */.Z)((0,parseISO/* default */.Z)(userData === null || userData === void 0 ? void 0 : userData.created_at), "dd MMM yyyy")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    ideaCount,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Posts"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " \xb7 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    followerCount,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Followers"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/index.tsx + 1 modules
var Post = __webpack_require__(3841);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(66350);
// EXTERNAL MODULE: ./src/lib/api/stream.ts
var stream = __webpack_require__(51679);
;// CONCATENATED MODULE: ./src/features/user/Guest/useGetStream.ts





function useGetStream(username) {
    var query = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "guestStream",
            username
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return stream/* default.getGuestUserStream */.Z.getGuestUserStream(username);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error occurred while fetching user stream.");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to get stream, unhandled error");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        retry: false
    });
    return query;
}
/* harmony default export */ var Guest_useGetStream = (useGetStream);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/global/StreamWidget/Skeleton/index.tsx
var Skeleton = __webpack_require__(23023);
;// CONCATENATED MODULE: ./src/features/user/Guest/StreamSkeleton.tsx




function StreamSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWrapper, {
        children: (0,_to_consumable_array/* default */.Z)(new Array(5)).map(function(val) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}, val);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/user/Guest/Stream.tsx






function Stream(param) {
    var username = param.username;
    var ref;
    var responseStream = Guest_useGetStream(username);
    var handleComment = function() {
        router_default().push("/login");
    };
    if (responseStream.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamSkeleton, {});
    }
    if (!responseStream.data) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWrapper, {
        children: responseStream === null || responseStream === void 0 ? void 0 : (ref = responseStream.data) === null || ref === void 0 ? void 0 : ref.map(function(post, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                    post: post,
                    onComment: handleComment,
                    isFirstPost: idx === 0,
                    dataCyName: "stream-guest-user-".concat(post.postid),
                    entryPoint: "guest-user"
                }, post.postid)
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/features/user/Guest/index.tsx





var GuestUser = function(param) {
    var username = param.username, user = param.user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestUserWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile, {
                user: user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stream, {
                username: username
            })
        ]
    });
};
function GuestUserPage(param) {
    var username = param.username, user = param.user;
    var client = new queryClient/* QueryClient */.S({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                staleTime: 1000 * 60 * 60
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
        client: client,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestUser, {
            username: username,
            user: user
        })
    });
};


/***/ }),

/***/ 63576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ PAGE_SOURCE_INDEX; },
/* harmony export */   "j4": function() { return /* binding */ mainProfileEvents; },
/* harmony export */   "nP": function() { return /* binding */ PAGE_SOURCE; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var PAGE_SOURCE;
(function(PAGE_SOURCE) {
    PAGE_SOURCE["streamPost"] = "Stream Post";
    PAGE_SOURCE["streamLikeList"] = "Stream Like List";
    PAGE_SOURCE["companyPage"] = "Company Page";
    PAGE_SOURCE["chat"] = "Chat";
    PAGE_SOURCE["search"] = "Search";
    PAGE_SOURCE["discoverPeople"] = "Discover People";
    PAGE_SOURCE["followers"] = "Followers";
    PAGE_SOURCE["following"] = "Following";
})(PAGE_SOURCE || (PAGE_SOURCE = {}));
var PAGE_SOURCE_INDEX = [
    "Stream Post",
    "Stream Like List",
    "Company Page",
    "Chat",
    "Search",
    "Discover People",
    "Followers",
    "Following",
    "My Profile",
    "Group Chat Bottom Sheet", 
];
var mainProfileEvents = {
    onViewProfile: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Stream View Profile", {
            "Page Source": pageSource
        });
    },
    onUserProfileViewed: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Viewed", {
            "Page Source": pageSource
        });
    },
    onUserProfileChatSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Chat Selected");
    },
    onUserProfileFollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Follow Selected");
    },
    onUserProfileUnfollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unfollow Selected");
    },
    onUserProfileTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn On Alert");
    },
    onUserProfileComposePost: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Compose Post");
    },
    onUserProfileAddorRemovefromWatchlist: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist");
    },
    onUserProfileBlock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block");
    },
    onUserProfileSuccessfullyTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn on alert");
    },
    onComposePostViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Compose Post Viewed");
    },
    onUserProfileAddOrRemoveFromWatchlistViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist Viewed");
    },
    onUserProfileBlockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block Confirmed");
    },
    onUserProfileSuccessfullyBlocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Blocked");
    },
    onUserProfileTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn Off Alert");
    },
    onUserProfileSuccessfullyTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn Off Alert");
    },
    onUserProfileUnblock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock");
    },
    onUserProfileUnblockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock Confirmed");
    },
    onUserProfileSuccessfullyUnblocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Unblock");
    }
};


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 37842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39211);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79644);







var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function GreenVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Verified Account"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: URL_VERIFICATION_ARTICLE,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Pelajari Lebih Lanjut"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/widget-trending/icon-verified.svg",
            style: {
                width: "12px",
                marginLeft: 5
            },
            alt: "icon-verified"
        })
    });
}
function GreyVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: "#858585",
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Account Verified"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Identitas user telah terverifikasi sebagai nasabah Stockbit Sekuritas"
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/verified-grey.svg",
            style: {
                width: "12px",
                marginLeft: 4
            },
            alt: "icon-verified"
        })
    });
}
function LabelVerifiedAccount(param) {
    var deprecatedVerifiedStatus = param.deprecatedVerifiedStatus, verifiedStatus = param.verifiedStatus;
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_COMMUNITY */ .P.VERIFIED_STATUS_COMMUNITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_IDENTITY */ .P.VERIFIED_STATUS_IDENTITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreyVerifiedBadge, {});
    }
    if (deprecatedVerifiedStatus && verifiedStatus === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (LabelVerifiedAccount);


/***/ }),

/***/ 94493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SH": function() { return /* reexport */ Labels_LabelAdmin; },
  "QP": function() { return /* reexport */ Labels_LabelTopUser; },
  "uC": function() { return /* reexport */ LabelVerifiedAccount/* default */.Z; }
});

// UNUSED EXPORTS: LabelPro, LabelSuspended, LabelVerified

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var common_Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
;// CONCATENATED MODULE: ./src/global/Labels/LabelAdmin.tsx





function LabelAdmin(param) {
    var privilege = param.privilege;
    if ((0,userRole/* getUserRole */.Rg)(privilege)) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: (0,userRole/* getUserRole */.Rg)(privilege)
            })
        }));
    }
    return null;
}
/* harmony default export */ var Labels_LabelAdmin = (LabelAdmin);

;// CONCATENATED MODULE: ./src/global/Labels/LabelPro.tsx




function LabelPro() {
    return(// @ts-expect-error
    /*#__PURE__*/ _jsx(Button, {
        p: "0px",
        margin: "0 2px",
        round: true,
        children: /*#__PURE__*/ _jsx(Text, {
            size: "10px",
            color: color.suvaGrey,
            padding: "2px",
            children: "PRO"
        })
    }));
}
/* harmony default export */ var Labels_LabelPro = ((/* unused pure expression or super */ null && (LabelPro)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/global/Labels/LabelSuspended.tsx



var LabelSuspended_Tag = Tag/* default.Tag */.Z.Tag;
function LabelSuspended() {
    return /*#__PURE__*/ _jsx(LabelSuspended_Tag, {
        style: {
            borderColor: color.sunsetOrange,
            color: color.sunsetOrange,
            fontWeight: "bold"
        },
        children: "Suspended"
    });
}
/* harmony default export */ var Labels_LabelSuspended = ((/* unused pure expression or super */ null && (LabelSuspended)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var common_Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/Labels/LabelTopUser.tsx





function LabelTopUser() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tooltip/* default */.Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Stockbit top users"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: "TOP"
            })
        })
    });
}
/* harmony default export */ var Labels_LabelTopUser = (LabelTopUser);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var common_Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/Labels/LabelVerified.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/jsx-wrap-multilines */ 




var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function LabelVerified() {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "rightTop",
        autoAdjustOverflow: true,
        overlayInnerStyle: {
            background: "rgba(64, 64, 64, 0.85)"
        },
        title: /*#__PURE__*/ _jsxs("p", {
            style: {
                marginBottom: 0
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    family: "bold",
                    color: color.light,
                    size: "12px",
                    style: {
                        lineHeight: "1.5"
                    },
                    children: "Verified Account"
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    color: color.light,
                    size: "12px",
                    height: "1.5",
                    children: [
                        "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.",
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                color: color.primary,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return window.open(URL_VERIFICATION_ARTICLE);
                            },
                            children: "Pelajari Lebih Lanjut"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(IconWrapper, {
            padding: "0 4px",
            children: /*#__PURE__*/ _jsx(Iconmoon, {
                className: "icon-custom_verified-circle",
                size: "12px",
                color: color.primary
            })
        })
    });
}
/* harmony default export */ var Labels_LabelVerified = ((/* unused pure expression or super */ null && (LabelVerified)));

// EXTERNAL MODULE: ./src/global/Labels/LabelVerifiedAccount.tsx
var LabelVerifiedAccount = __webpack_require__(37842);
;// CONCATENATED MODULE: ./src/global/Labels/index.tsx








/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66951);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(56266);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 























var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_15__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FooterContainer */ .bk, {
        className: "stream-footer-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    getPopupContainer: function() {
                                        return(// @ts-expect-error
                                        document.getElementsByClassName("stream-footer-container")[0]);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray,
                                    hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_9__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);




function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        // @ts-expect-error
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: isCompanyPinnedPost ? "Pinned Post by Stockbit" : text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx














function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: color/* default.midgray */.Z.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 





















var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3503);


function Skeleton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonBox */ .HX, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonLeft */ .yt, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonAvatar */ .JT, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonRight */ .wW, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonUsername */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonDate */ .hT, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .StreamSkeletonContent */ .vP, {})
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);


/***/ }),

/***/ 3503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ StreamSkeletonBox; },
/* harmony export */   "JT": function() { return /* binding */ StreamSkeletonAvatar; },
/* harmony export */   "Tg": function() { return /* binding */ StreamSkeletonContainer; },
/* harmony export */   "Z": function() { return /* binding */ StreamSkeletonUsername; },
/* harmony export */   "hT": function() { return /* binding */ StreamSkeletonDate; },
/* harmony export */   "mN": function() { return /* binding */ ShortBar; },
/* harmony export */   "mr": function() { return /* binding */ LongBar; },
/* harmony export */   "pl": function() { return /* binding */ Thumbnail; },
/* harmony export */   "vP": function() { return /* binding */ StreamSkeletonContent; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "wW": function() { return /* binding */ StreamSkeletonRight; },
/* harmony export */   "yt": function() { return /* binding */ StreamSkeletonLeft; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  padding: 20px;\n\n  &:last-child {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #f7f7f7;\n  border-radius: 4px;\n  height: 16px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30%;\n\n  @media ",
        " {\n    width: 20%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: ",
        ";\n      min-width: ",
        ";\n      width: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 6px;\n  margin-left: 33px;\n  height: 75px;\n  width: 100px;\n  min-width: 100px;\n\n  @media ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #ededed;\n  padding: 20px;\n  position: relative;\n  background: #fff;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 50px;\n  width: 50px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40px;\n  height: 40px;\n  background: #f7f7f7;\n  border-radius: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 50px;\n  width: calc(100% - 50px);\n  position: relative;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 229px;\n  height: 16px;\n  background: #f7f7f7;\n  border-radius: 4px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 87px;\n  height: 16px;\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 8px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 88px;\n  background: #f7f7f7;\n  border-radius: 4px;\n  margin-top: 20px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var StreamSkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
var ContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    justify: "center"
}).withConfig({
    componentId: "sc-1f958481-1"
})(_templateObject1());
var LongBar = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-2"
})(_templateObject2());
var ShortBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(LongBar).withConfig({
    componentId: "sc-1f958481-3"
})(_templateObject3(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet);
var Thumbnail = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(LongBar).withConfig({
    componentId: "sc-1f958481-4"
})(_templateObject5(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, function(param) {
    var height = param.height, width = param.width;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), height, width, width);
});
var StreamSkeletonBox = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-5"
})(_templateObject6());
var StreamSkeletonLeft = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-6"
})(_templateObject7());
var StreamSkeletonAvatar = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-7"
})(_templateObject8());
var StreamSkeletonRight = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-8"
})(_templateObject9());
var StreamSkeletonUsername = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-9"
})(_templateObject10());
var StreamSkeletonDate = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-10"
})(_templateObject11());
var StreamSkeletonContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1f958481-11"
})(_templateObject12());



/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .Z.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ }),

/***/ 58080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ isAllowedToBlockIp; },
/* harmony export */   "Rg": function() { return /* binding */ getUserRole; },
/* harmony export */   "_W": function() { return /* binding */ isAllowedToManageTop; },
/* harmony export */   "w1": function() { return /* binding */ isAllowedToSuspend; },
/* harmony export */   "xj": function() { return /* binding */ UserRoleName; }
/* harmony export */ });
/* unused harmony exports isAllowedToDelete, isAllowedToMultiDelete */
var UserRole = [
    "MEMBER",
    "ADMIN",
    "MODERATOR",
    "CONFIGURATOR",
    "SUPER_ADMIN", 
];
var UserRoleName = {
    MEMBER: "Member",
    ADMIN: "ADMIN",
    MODERATOR: "ADMIN",
    CONFIGURATOR: "CONFIGURATOR",
    SUPER_ADMIN: "ADMIN"
};
var checkPrivilege = function(userPriv, allowed) {
    return allowed.indexOf("".concat(userPriv)) >= 0;
};
var isAllowedToDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToMultiDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToSuspend = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToBlockIp = function(userPriv) {
    return checkPrivilege(userPriv, [
        "4"
    ]);
};
var isAllowedToManageTop = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "4"
    ]);
};
var getUserRole = function(userPriv) {
    if (!checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ])) {
        return "";
    }
    var role = UserRole[userPriv];
    return UserRoleName[role];
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserRole)));


/***/ })

}]);